import { z } from "zod";
export const cdpiScoreOverviewSchema = z.object({
    deviceSerialNumber: z.string(),
    LDN: z.number(),
    deviceType: z.string().nullable(),
    CPDI: z.number(),
    firstTimeRightIndex: z.number(),
    firstTimeRightPercentage: z.number(),
    failuresConnectionPerformance: z.number(),
    failuresConnectionPerformanceIndex: z.number(),
    connectionTime: z.number(),
    connectionTimeIndex: z.number(),
    connectionAttempts: z.number(),
    connectionAttemptsIndex: z.number(),
    previousWeekCPDIChange: z.number().nullable(),
});
//# sourceMappingURL=cpdi-score-overview.schema.js.map